import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { SupplementaryEquipmentSight } from './has-supplementary-equipment.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterCondition } from '../../../../filter-administration.model';

export class VisitorRole {
  id: string;
  nameDictionaryKey: string;
}

@Component({
  selector: 'app-has-supplementary-equipment-condition-editor',
  templateUrl: './has-supplementary-equipment-condition-editor.component.html',
  styleUrls: ['./has-supplementary-equipment-condition-editor.component.scss']
})
export class HasSupplementaryEquipmentConditionEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  equipments: Array<SupplementaryEquipmentSight>;

  formGroup: FormGroup;

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  resettingFormValues = false;

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI
  ) {

  }


  ngOnInit(): void {
    this.appServerAPI.execute<VisitorRole[]>('/client/admin/filter/get-supplementary-equipment', {}).subscribe(
      result => {
        const equipments = new Array<SupplementaryEquipmentSight>();
        for (const equipment of result) {
          equipments.push(new SupplementaryEquipmentSight(equipment));
        }
        this.equipments = equipments;
        let formGroup = new FormGroup({});
        for (let equipment of equipments) {
          formGroup.addControl('cb-' + equipment.id, new FormControl(null, []));
        }
        this.formGroup = formGroup;
        this.resetForm();

        this.formGroup.valueChanges.subscribe(value => {
          let ids = new Array<number>();
          for (let equipment of equipments) {
            if (value['cb-' + equipment.id]) {
              ids.push(equipment.id);
            }
          }
          this.condition.data = ids;
          if (!this.resettingFormValues) {
            this.filterAdministrationContext.getFilter().dirty = true;
          }
        });

      }
    );
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    console.log('setFilterAdministrationContext');
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        console.log('change is', change);
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    if (this.formGroup == null || this.condition.data == null) {
      return;
    }
    if (!(typeof this.condition.data[Symbol.iterator] === 'function')) {
      return;
    }
    this.resettingFormValues = true;
    console.log('condition data is', this.condition.data);
    let value = {};

    for (let id of this.condition.data) {
      value['cb-' + id] = true;
    }
    this.formGroup.patchValue(value);
    this.formGroup.markAsPristine();
    this.resettingFormValues = false;
  }

}
